export default __webpack_public_path__ + "static/media/093-diagonal-arrow-13.a590dd4a.png";